export { ErrorState, ErrorStateInner } from './ErrorState';
